<template>
  <div>
    <v-app-bar
      app
      color="appMenu"
      dense
      class="fill-height"
      dark
      height="32"
      fixed
    >
      <v-icon left> mdi-update</v-icon>Product Update
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <ejs-inplaceeditor
            ref="rteObj"
            id="inplace_description_editor"
            data-underline="false"
            mode="Inline"
            editableOn="EditIconClick"
            :disabled="true"
            submitOnEnter="false"
            type="RTE"
            emptyText="Product Update"
            name="rte"
            v-model="description"
            :model="commentModel"
          >
          </ejs-inplaceeditor>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import { InPlaceEditorPlugin, Rte } from "@syncfusion/ej2-vue-inplace-editor";

Vue.use(InPlaceEditorPlugin);

export default {
  name: "ProductUpdate",
  data() {
    return {
      description: "",
    };
  },
  computed: {
    commentModel() {
      return {
        toolbarSettings: {
          enableFloating: false,
          items: [
            "Bold",
            "Italic",
            "Underline",
            "FontColor",
            "BackgroundColor",
            "LowerCase",
            "UpperCase",
            "|",
            "OrderedList",
            "UnorderedList",
          ],
        },
      };
    },
  },
  provide: {
    inplaceeditor: [Rte],
  },
};
</script>

<style>
</style>